import { render } from "./LookingForPayment.vue?vue&type=template&id=cfc433fa"
import script from "./LookingForPayment.vue?vue&type=script&lang=js"
export * from "./LookingForPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__